// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Close from "@store/Library/Components/Toolkit/Icons/Close";
import { buttonResetStyles } from "@store/Themes/common/mixins/button";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

// Store Custom Code - >
const tag: Styleguide["tag"] = {
    defaultProps: {
        color: "common.accent", // Store Custom Code
        typographyProps: {
            color: "primary",
        },
        iconProps: {
            size: 20,
            color: "primary",
        },
        css: css`
            display: flex;
            align-items: center;
            padding: 0.3em 0.5em 0.3em 0.75em;
            border-radius: 1em;
            margin: 0 ${pxToRem(10)} ${pxToRem(13)} 0;

            button {
                min-width: 0;
                min-height: 0;

                &:hover {
                    background-color: transparent;

                    * {
                        color: ${getColor("info.main")};
                    }
                }

                /* This mixin has to be declared after other properties otherwise following properties were straight out ignored */
                ${transitionHoverStyles()}
            }
        `,
    },
};
// <-- Majestic Custom Code
export default tag;
